module.exports = __webpack_public_path__ + "media/images/sakoju_image-a283fa2e4dd7b8f0d74c228e6ac6d334.png";